import { ObjectDataType, UnionDataType } from '../DataType';

export const PlainDateDataType: ObjectDataType = {
    name: 'Date',
    restriction: 'exact',
    kind: 'object',
    properties: {
        year: { kind: 'number' },
        month: { kind: 'number' },
        day: { kind: 'number' },
    },
};

export const PlainTimeDataType: ObjectDataType = {
    name: 'Time',
    restriction: 'exact',
    kind: 'object',
    properties: {
        hour: { kind: 'number' },
        minute: { kind: 'number' },
        second: { kind: 'number' },
        millisecond: { kind: 'number' },
    },
};

export const PlainDateTimeDataType: ObjectDataType = {
    name: 'DateTime',
    restriction: 'exact',
    kind: 'object',
    properties: {
        year: { kind: 'number' },
        month: { kind: 'number' },
        day: { kind: 'number' },
        hour: { kind: 'number' },
        minute: { kind: 'number' },
        second: { kind: 'number' },
        millisecond: { kind: 'number' },
    },
};

export const ZonedDateTimeDataType: ObjectDataType = {
    name: 'ZonedDateTime',
    restriction: 'exact',
    kind: 'object',
    properties: {
        year: { kind: 'number' },
        month: { kind: 'number' },
        day: { kind: 'number' },
        hour: { kind: 'number' },
        minute: { kind: 'number' },
        second: { kind: 'number' },
        millisecond: { kind: 'number' },
        timeZone: { kind: 'string' },
        offset: { kind: 'string' },
    },
};

export const DurationDataType: ObjectDataType = {
    name: 'Duration',
    restriction: 'exact',
    kind: 'object',
    properties: {
        years: { kind: 'number' },
        months: { kind: 'number' },
        weeks: { kind: 'number' },
        days: { kind: 'number' },
        hours: { kind: 'number' },
        minutes: { kind: 'number' },
        seconds: { kind: 'number' },
        milliseconds: { kind: 'number' },
    },
};

export const InstantDataType: ObjectDataType = {
    name: 'Instant',
    restriction: 'exact',
    kind: 'object',
    properties: {
        epochMilliseconds: { kind: 'number' },
    },
};

export const DateLikeUnion: UnionDataType = {
    kind: 'union',
    subTypes: [PlainDateDataType, PlainDateTimeDataType, ZonedDateTimeDataType],
};

export const TimeLikeUnion: UnionDataType = {
    kind: 'union',
    subTypes: [PlainTimeDataType, PlainDateTimeDataType, ZonedDateTimeDataType],
};

export const TemporalValueUnion: UnionDataType = {
    kind: 'union',
    subTypes: [PlainDateDataType, PlainTimeDataType, PlainDateTimeDataType, ZonedDateTimeDataType],
};
